var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('c-switch',{attrs:{"color":"success","pill":""},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_c('b-form-invalid-feedback',{staticStyle:{"display":"block"},attrs:{"id":_vm.field.key}},[_vm._v("\n      "+_vm._s(_vm.errors[0] || null)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }